module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12.043\" height=\"8.167\" viewBox=\"0 0 12.043 8.167\">\n  <g transform=\"translate(-40.457 -127.5)\">\n    <path d=\"M-1728.005,1797.938l3.083,3.083-3.083,3.083\" transform=\"translate(-1683.051 1932.604) rotate(180)\"\n          fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"2\"/>\n    <line x2=\"9\" transform=\"translate(42.5 131.5)\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n          stroke-width=\"2\"/>\n  </g>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./app/assets/images/icons/btn_arrow.svg
// module id = 851
// module chunks = 1